// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2DtOu","messages":"Chat_messages__B3sMH","dateDivider":"Chat_dateDivider__3sGk1"};